(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateEmbedVisibility = (selectedValue, container, topicValues) => {
      const embedElements = Array.from(container.children).filter((child) => child.nodeType === 1);

      embedElements.forEach((element, index) => {
        const topicValue = topicValues[index];
        if (topicValue) {
          element.dataset.contactFormTopic = topicValue;
        }

        const isVisible = selectedValue !== '' && element.dataset.contactFormTopic === selectedValue;
        element.hidden = !isVisible;
        element.setAttribute('aria-hidden', String(!isVisible));
      });
    };

    const initCustomDropdown = (block, container) => {
      const dropdown = block.querySelector('[data-contact-form-dropdown]');
      if (!dropdown) return null;

      const trigger = dropdown.querySelector('[data-contact-form-topic-trigger]');
      const label = dropdown.querySelector('[data-contact-form-topic-label]');
      const listbox = dropdown.querySelector('[data-contact-form-topic-list]');
      const hiddenInput = dropdown.querySelector('[data-contact-form-topic-value]');
      const options = Array.from(dropdown.querySelectorAll('[data-contact-form-topic-option]'));
      const topicValues = options.slice(1).map((option) => option.dataset.value || '');
      let activeIndex = 0;

      if (!trigger || !label || !listbox || !hiddenInput || options.length === 0) {
        return null;
      }

      const closeDropdown = () => {
        trigger.setAttribute('aria-expanded', 'false');
        listbox.hidden = true;
      };

      const openDropdown = () => {
        trigger.setAttribute('aria-expanded', 'true');
        listbox.hidden = false;
        options[activeIndex]?.focus();
      };

      const setActiveOption = (newIndex) => {
        activeIndex = Math.max(0, Math.min(newIndex, options.length - 1));
        options[activeIndex]?.focus();
      };

      const selectOption = (index) => {
        const option = options[index];
        if (!option) return;

        const nextValue = option.dataset.value || '';
        const nextLabel = option.textContent ? option.textContent.trim() : '';

        options.forEach((item) => item.setAttribute('aria-selected', 'false'));
        option.setAttribute('aria-selected', 'true');

        hiddenInput.value = nextValue;
        label.textContent = nextLabel;
        activeIndex = index;

        updateEmbedVisibility(nextValue, container, topicValues);
        closeDropdown();
        trigger.focus();
      };

      trigger.addEventListener('click', () => {
        if (listbox.hidden) {
          openDropdown();
        } else {
          closeDropdown();
        }
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Tab') {
          closeDropdown();
          return;
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openDropdown();
        }
      });

      listbox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActiveOption(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActiveOption(activeIndex - 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          setActiveOption(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          setActiveOption(options.length - 1);
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectOption(activeIndex);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeDropdown();
          trigger.focus();
        } else if (event.key === 'Tab') {
          closeDropdown();
        }
      });

      options.forEach((option, index) => {
        option.addEventListener('click', () => selectOption(index));
      });

      document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target)) {
          closeDropdown();
        }
      });

      updateEmbedVisibility('', container, topicValues);
      return true;
    };

    const initContactFormEmbeds = () => {
      const blocks = document.querySelectorAll('.contact-form');

      blocks.forEach((block) => {
        const container = block.querySelector('[data-contact-form-embeds]');

        if (!container) return;
        initCustomDropdown(block, container);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initContactFormEmbeds);
    } else {
      initContactFormEmbeds();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
